<template>
  <div class="mmain">
    <div class="wrapper">
      <mNewsList fenlei="政策法规"></mNewsList>
    </div>
  </div>
</template>
<script>
import mNewsList from "@/components/mNewsList.vue";
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
  },
  components: {
    mNewsList
  }
};
</script>
<style lang="less" scoped>
.mmain {
  width: 100%;
}
</style>